import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import type { DiscountRule } from '@wix/ambassador-ecom-discount-rules-v2-discount-rule/types';
import { queryDiscountRules } from '@wix/ambassador-ecom-discount-rules-v2-discount-rule/http';

const getEligibleDiscountRules = async ({
  flowAPI,
}: {
  flowAPI: ControllerFlowAPI;
}): Promise<DiscountRule[]> => {
  const { data } = await flowAPI.httpClient.request(
    queryDiscountRules({ query: { filter: { active: true } } }),
  );

  return data.discountRules ?? [];
};

export const discountRulesService = {
  getEligibleDiscountRules,
};
